import type { audit as en } from '@/i18n/locales/en/audit';
import type { Translation } from '@/i18n/types';

export const audit: Translation<typeof en> = {
  page: {
    title: 'Registro de auditoría',
    scopedLead:
      'Ves las acciones permitidas para tus propias empresas; las respuestas de consentimiento y los enlaces de identidad nunca se incluyen.',
    actionFilter: 'Filtrar por acción',
    actionPlaceholder: 'acción, p. ej. department.visibility.update',
    scopeFilter: 'Filtrar por ámbito',
    scopePlaceholder: 'id del ámbito',
    filter: 'Filtrar',
    empty: 'No hay filas de auditoría.',
    when: 'Cuándo',
    action: 'Acción',
    actorRole: 'Rol del actor',
    target: 'Objetivo',
    rowsLabel: 'las filas de auditoría',
  },
};
